// extracted by mini-css-extract-plugin
module.exports = {"w1997lpl":"w1997lpl","s1pxkd12":"s1pxkd12","ppw3vqu":"ppw3vqu","o1pb353l":"o1pb353l"};